var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighSeverity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A High Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.41098964,0.403324374 L11.286894,8.5906151 C11.520225,8.98240875 11.3917656,9.48917237 10.999972,9.72250332 C10.8721869,9.79860517 10.7262186,9.83877826 10.5774889,9.83877826 L0.825680091,9.83877826 C0.369669568,9.83877826 0,9.46910869 -1.11022302e-16,9.01309817 C-1.11022302e-16,8.86436847 0.0401730936,8.7184002 0.116274939,8.5906151 L4.99217934,0.403324374 C5.22551029,0.0115307269 5.73227391,-0.116928666 6.12406756,0.116402289 C6.24208583,0.186687543 6.34070439,0.285306103 6.41098964,0.403324374 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Investigations-small-screen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-208.000000, -365.000000)",
    id: "A-High-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.191801, 365.698483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3-+-Oval-Mask-Copy",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighSeverity);
export default __webpack_public_path__ + "static/media/high-severity.71535386b32ff3a78690efed73ef5a70.svg";
export { ForwardRef as ReactComponent };